import './filter-button-dropdown.component.scss';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { useAppFilterSelectedValue } from '../../../../hooks/filters/use-app-filter-selected-value.hook';
import { FilterComponentProps } from '../../interfaces/filter-component-props.interface';
import { FilterButtonDropdownBasicComponent } from './filter-button-dropdown-basic.component';

export interface FilterButtonComponentProps extends FilterComponentProps {
  variant?: 'stand-alone' | 'simple' | '';
  searchBox?: boolean;
  defaultLabel?: string;
  onSelect?(selectedValue?: FilterSelectedValue): void;
}

/**
 * Stores filter selection in global variables.
 * @param
 * @returns
 */
export const FilterButtonDropdownComponent = ({
  onSelect,
  filter,
  filterSelection,
  disabled,
  variant = '',
  searchBox = true,
  defaultLabel = 'All',
  disabledOptions,
}: FilterButtonComponentProps) => {
  const { selectedValue, setSelectedValue } = useAppFilterSelectedValue(
    filter.id,
  );
  return (
    <FilterButtonDropdownBasicComponent
      selectedValue={selectedValue}
      setSelectedValue={setSelectedValue}
      onSelect={onSelect}
      filter={filter}
      filterSelection={filterSelection}
      disabled={disabled}
      variant={variant}
      searchBox={searchBox}
      defaultLabel={defaultLabel}
      disabledOptions={disabledOptions}
    />
  );
};
